<template>
  <chart-container :title="title">
    <apexchart
      type="radialBar"
      :height="computedOptions.height"
      :options="computedOptions"
      :series="computedSeries"
    />
  </chart-container>
</template>

<script>
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { ApexBaseChartOptions } from "@/commons/chart-commons.js";

export default {
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedOptions() {
      const { label, value } = this.options;
      const localOptions = {
        height: (this.height || ApexBaseChartOptions.height) * 1.083,
        plotOptions: {
          radialBar: {
            hollow: {
              size: `${value}%`,
            },
          },
        },
        labels: [label],
      };
      return _merge({}, ApexBaseChartOptions, localOptions);
    },
    computedSeries() {
      return [this.options.value];
    },
  },
};
</script>